import React, { useState, useEffect } from "react";
import NavbarDev, { loadNav } from "./Navbar";
import Loader from "../../components/Loader";
import Input from "../../components/Input";
import Alert from "../../components/Alert";
import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";

const Impostazioni = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [avvisoPreScadenza, setAvvisoPreScadenza] = useState(0);
    const [giorniCuscinetto, setGiorniCuscinetto] = useState(0);
    const [durataTrial, setDurataTrial] = useState(0);
    const [originalData, setOriginalData] = useState([]);
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        onload();
    }, []);

    const onload = async () => {
        setIsLoading(true);

        await loadNav();

        try {
            const r = await fetch("/getParametri", {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });

            const rd = await r.json();

            if (r.status === 500) {
                console.log(rd["error"]);
                setAlertInfo({ type: "error", text: rd["error"], onClose: () => { navigate("/dev/dash"); }, needConfirm: false });
                setShowAlert(true);
            }
            else {
                setOriginalData(rd);
                setAvvisoPreScadenza(rd[0].AvvisoPreScadenza);
                setGiorniCuscinetto(rd[0].GiorniCuscinetto);
                setDurataTrial(rd[0].DurataTrialMesi);
            }
        } catch (error) {
            console.error("Error loading parameters:", error);
            setAlertInfo({ type: "error", text: "Errore di connessione al server.", onClose: () => {navigate("/dev/dash");}, needConfirm: false });
            setShowAlert(true);
        }

        setIsLoading(false);
    };

    const checkParametri = () => {
        if (parseInt(giorniCuscinetto) !== originalData[0].GiorniCuscinetto) {
            setIsEditing(true);
            return;
        }

        if (parseInt(avvisoPreScadenza) !== originalData[0].AvvisoPreScadenza) {
            setIsEditing(true);
            return;
        }

        if (parseInt(durataTrial) !== originalData[0].DurataTrialMesi) {
            setIsEditing(true);
            return;
        }

        setIsEditing(false);
    };

    const handleConferma = async () => {
        if (avvisoPreScadenza < 0 || giorniCuscinetto < 0 || durataTrial < 0) {
            setAlertInfo({ type: "warning", text: "I valori non possono essere negativi.", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }

        setIsLoading(true);

        try {
            const r = await fetch("/aggiornaParametri", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ AvvisoPreScadenza: avvisoPreScadenza, GiorniCuscinetto: giorniCuscinetto, DurataTrialMesi: durataTrial }),
            });

            if (r.status === 200) {
                window.location.reload();
            } else {
                const rd = await r.json();
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => { window.location.reload(); }, needConfirm: false });
                setShowAlert(true);
            }
        } catch (error) {
            console.error("Error updating parameters:", error);
            setAlertInfo({ type: "error", text: "Errore durante l'aggiornamento dei parametri.", onClose: () => { window.location.reload(); }, needConfirm: false });
            setShowAlert(true);
        }

        setIsLoading(false);
    };

    return (
        <div className="h-[100svh]">
            <NavbarDev page={"IMPOSTAZIONI"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto flex flex-col justify-center items-center">
                <Input
                    label="Avviso pre-scadenza (giorni) *"
                    value={avvisoPreScadenza}
                    setValue={setAvvisoPreScadenza}
                    type="number"
                    classes="w-[80%] md:w-[50%] mt-1"
                    disabled={false}
                    error={false}
                    blurAction={checkParametri}
                />
                <Input
                    label="Giorni cuscinetto *"
                    value={giorniCuscinetto}
                    setValue={setGiorniCuscinetto}
                    type="number"
                    classes="w-[80%] md:w-[50%] mt-3"
                    disabled={false}
                    error={false}
                    blurAction={checkParametri}
                />
                <Input
                    label="Durata trial (mesi) *"
                    value={durataTrial}
                    setValue={setDurataTrial}
                    type="number"
                    classes="w-[80%] md:w-[50%] mt-3"
                    disabled={false}
                    error={false}
                    blurAction={checkParametri}
                />
                {
                    isEditing && (
                        <div className="w-[80%] md:w-[50%] mt-3 grid grid-cols-2 gap-4">
                            <Button
                                type="hollow"
                                onClick={() => {
                                    setIsEditing(false);
                                    setAvvisoPreScadenza(originalData[0].AvvisoPreScadenza);
                                    setGiorniCuscinetto(originalData[0].GiorniCuscinetto);
                                    setDurataTrial(originalData[0].DurataTrialMesi);
                                }}>
                                ANNULLA
                            </Button>
                            <Button type="full" onClick={handleConferma}>
                                CONFERMA
                            </Button>
                        </div>
                    )
                }
            </div>
        </div>
    )
};
export default Impostazioni;